import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import "./Footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaYoutube,
} from "react-icons/fa";
import { AdminContext } from "./AdminContext";

const Footer = () => {
  const { isAdmin, login, logout } = useContext(AdminContext);

  return (
    <>
      {/* Structured Data for Local Business */}
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Dr. Chavan Multispeciality Hospital",
              "image": "https://drchavanhospital.in/images/lg.png",
              "url": "https://drchavanhospital.in/",
              "telephone": "+91 12345 67890",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Opp. to Irrigation Colony, Kalthan Road",
                "addressLocality": "Indapur",
                "addressRegion": "Maharashtra",
                "postalCode": "413106",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": "XX.XXXXXX",
                "longitude": "XX.XXXXXX"
              },
              "openingHours": "Mo-Su 08:00-20:00",
              "sameAs": [
                "https://www.facebook.com/drchavanhospital",
                "https://www.instagram.com/drchavanhospital",
                "https://www.linkedin.com/company/drchavanhospital"
              ]
            }
          `}
        </script>
      </Helmet>

      <footer className="footer" role="contentinfo" aria-label="Footer Section">
        <div className="footer-top">
          {/* About Section */}
          <div className="footer-about">
            <h2>Dr. Chavan Multispeciality Hospital</h2>
            <p>
              Providing compassionate, world-class healthcare with cutting-edge
              technology and experienced medical professionals.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/" title="Home">
                  Home
                </a>
              </li>
              <li>
                <a href="/services" title="Services">
                  Services
                </a>
              </li>
              <li>
                <a href="/doctors" title="Doctors">
                  Doctors
                </a>
              </li>
              <li>
                <a href="/appointments" title="Appointments">
                  Appointments
                </a>
              </li>
              <li>
                <a href="/contact" title="Contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <ul>
              <li>
                <FaMapMarkerAlt aria-hidden="true" />
                <span>
                  Dr. Chavan Multispeciality Hospital, Opp. to Irrigation
                  Colony, Kalthan Road, Indapur - 413106
                </span>
              </li>
              <li>
                <FaPhoneAlt aria-hidden="true" />{" "}
                <a
                  href="tel:+917249693033"
                  aria-label="Call Hospital"
                  style={{ color: "white" }}
                >
                  +91 7249693033
                </a>
              </li>
              <li>
                <FaEnvelope aria-hidden="true" />{" "}
                <a
                  href="mailto:chavanhospitalindapur@gmail.com"
                  aria-label="Email Hospital"
                  style={{ color: "white" }}
                >
                  chavanhospitalindapur@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media + Admin */}
          <div className="footer-social-admin">
            <div className="social-icons" aria-label="Social Media Links">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Youtube"
              >
                <FaYoutube />
              </a>
              <a
                href="https://www.instagram.com/chavanhospitalindapur?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>

            {/* Admin Login / Logout Button */}
            <button
              onClick={isAdmin ? logout : login}
              className={`footer-admin-btn ${
                isAdmin ? "logout-footer" : "login-lock"
              }`}
              aria-label={isAdmin ? "Logout Admin Panel" : "Admin Login"}
            >
              {isAdmin ? "Logout" : "🔒"}
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Dr. Chavan Multispeciality Hospital.
            All rights reserved.
          </p>

          <p>
            
            <a
              href="https://elevatedev.in"
              target="_blank"
              rel="noopener noreferrer"
              className="designer-link"
              
            >
              Designed by ElevateDev.in
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
